import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/accessible-icon': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M423.9 255.8l-12.9 157.3c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26l-39.3-39.3c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6l-58.4 66.5 106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zM359 101.8c-28.1 0-50.9-22.8-50.9-50.9 0-28.1 22.8-50.9 50.9-50.9s50.9 22.8 50.9 50.9c0 28.1-22.8 50.9-50.9 50.9zM179.6 456.5c20.8 0 40.1-6.4 56.1-17.3l39.7 39.7c-100.7 78.9-251.4 8.2-251.4-122.5 0-36.1 12.4-69.4 33.2-95.7l39.7 39.7c-44.7 65.5 2.1 156.1 82.7 156.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/accessible-icon.js
// module id = 693
// module chunks = 0